import React from 'react';
import Loader from '../Loader/Loader';
const SendConfirmationModal = ({ templateTitle, siteName, recipients, scheduledSendAt, isSending, onCancel, onConfirm }) => {
    const total = recipients.users + recipients.newsletterSubscribers;
    return (React.createElement("div", { className: "fixed inset-0 z-60 flex items-center justify-center bg-black/60", role: "alertdialog", "aria-modal": "true", "aria-labelledby": "send-confirmation-title" },
        React.createElement("div", { className: "bg-white rounded-2xl p-6 w-11/12 max-w-md flex flex-col gap-4" },
            React.createElement("h4", { id: "send-confirmation-title", className: "font-semibold text-gray-800 text-xl" }, scheduledSendAt
                ? 'Schedule this mailout?'
                : 'Send this mailout now?'),
            React.createElement("div", { className: "text-gray-700 text-base flex flex-col gap-1" },
                React.createElement("p", null,
                    React.createElement("strong", null, templateTitle),
                    " on ",
                    React.createElement("strong", null, siteName)),
                React.createElement("p", { className: "text-2xl font-semibold text-gray-800" },
                    total,
                    " recipients"),
                React.createElement("p", null,
                    recipients.users,
                    " users and ",
                    recipients.newsletterSubscribers,
                    ' ',
                    "newsletter subscribers without an account"),
                React.createElement("p", { className: "text-sm" },
                    scheduledSendAt
                        ? `Scheduled for ${scheduledSendAt
                            .replace('T', ' ')
                            .replace(':00Z', '')} GMT.`
                        : 'Sending starts within 15 minutes.',
                    ' ',
                    "People who already got this newsletter from another network's mailout are skipped, so fewer may receive it.")),
            React.createElement("div", { className: "flex gap-2 justify-end" },
                React.createElement("button", { type: "button", onClick: onCancel, disabled: isSending, className: "px-4 py-2 font-semibold text-base rounded-md bg-gray-200 text-gray-800" }, "Cancel"),
                React.createElement("button", { type: "button", onClick: onConfirm, disabled: isSending, className: "px-4 py-2 font-semibold text-base rounded-md bg-blue-600 text-white" }, isSending ? (React.createElement(Loader, { title: scheduledSendAt ? 'Scheduling...' : 'Sending...' })) : scheduledSendAt ? ('Schedule Mailout') : ('Send Now'))))));
};
export default SendConfirmationModal;
